export const convertToUTC = (date: Date | string): Date => {
  const d = new Date(date);
  return new Date(d.getTime() + d.getTimezoneOffset() * 60000);
};

export const utcDateNow = convertToUTC(new Date());

export const not72HoursWindow = (date: string): boolean => {
  const utcDepartureDate = convertToUTC(date);
  return (utcDepartureDate.getTime() - utcDateNow.getTime()) / 3600000 > 72;
};
